import {NotifyHelper} from "../../../helpers/toast";
import {eAccConfigInvoiceActionsObj} from "../../action-types/category/IAccConfigInvoiceActions";
import {generateActionForKey, generateActions} from "../generateActions";

export const configInvoiceActions = {
    ...generateActions(eAccConfigInvoiceActionsObj, "CONFIG_INVOICE"),
    ...generateActionForKey(
        eAccConfigInvoiceActionsObj,
        "CONFIG_INVOICE",
        "SAVE_SUCCESS",
        () => {
            NotifyHelper.Success("Đã cập nhật");
        }
    ),
    ...generateActionForKey(
        eAccConfigInvoiceActionsObj,
        "CONFIG_INVOICE",
        "SAVE_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
    ...generateActionForKey(
        eAccConfigInvoiceActionsObj,
        "CONFIG_INVOICE",
        "DELETE_SUCCESS",
        () => {
            NotifyHelper.Success("Đã xóa");
        }
    ),
    ...generateActionForKey(
        eAccConfigInvoiceActionsObj,
        "CONFIG_INVOICE",
        "DELETE_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
    ...generateActionForKey(
        eAccConfigInvoiceActionsObj,
        "CONFIG_INVOICE",
        "DELETE_MANY_SUCCESS",
        () => {
            NotifyHelper.Success("Đã xóa");
        }
    ),
    ...generateActionForKey(
        eAccConfigInvoiceActionsObj,
        "CONFIG_INVOICE",
        "DELETE_MANY_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
};
